module.exports = __webpack_public_path__ + "static/media/WorkflowIcon.c1d5375f.svg";